import 'css-chunksrc/feature/seat-assignment/CheckItemSeatSelection.module.scss';export default {
  "optionsScrollContainer": "CheckItemSeatSelection_optionsScrollContainer",
  "optionsContainer": "CheckItemSeatSelection_optionsContainer"
};